module.exports = __webpack_public_path__ + "img/squiggle-vertical.7b7c4d4a.svg";